/* import __COLOCATED_TEMPLATE__ from './submit-button.hbs'; */
import { classNameBindings, classNames } from '@ember-decorators/component';
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './submit-button.module.scss';

@classic
@classNames('submit-button', styles.component)
@classNameBindings('isActive:active')
export default class RequestSubmitButton extends Component {
  @service currentPractice;
  @service session;

  @reads('currentPractice.useBookAppointmentLanguage') useBookAppointmentLanguage;

  get dataProcessingConsentKey() {
    return this.isCreditCardRequired
      ? 'booking.disclaimer.dataProcessingConsent'
      : 'consent.dataProcessingConsent';
  }
}
